module.exports = __webpack_public_path__ + "static/lampenschirm_1.0987f9ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fulls/lampenschirm_1.jpg
// module id = 551
// module chunks = 35783957827783